/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Motivation_ShortInputs */

const en_us2_intake_why_motivation_short = /** @type {(inputs: Intake_Why_Motivation_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets the tone, not the plan`)
};

const pt_br2_intake_why_motivation_short = /** @type {(inputs: Intake_Why_Motivation_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define o tom, não o plano`)
};

const es_419_intake_why_motivation_short = /** @type {(inputs: Intake_Why_Motivation_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define el tono, no el plan`)
};

const pt_pt2_intake_why_motivation_short = /** @type {(inputs: Intake_Why_Motivation_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define o tom, não o plano`)
};

const fr_fr2_intake_why_motivation_short = /** @type {(inputs: Intake_Why_Motivation_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donne le ton, pas le programme`)
};

const de_de2_intake_why_motivation_short = /** @type {(inputs: Intake_Why_Motivation_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestimmt den Ton, nicht den Plan`)
};

const it_it2_intake_why_motivation_short = /** @type {(inputs: Intake_Why_Motivation_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decide il tono, non la scheda`)
};

/**
* | output |
* | --- |
* | "Sets the tone, not the plan" |
*
* @param {Intake_Why_Motivation_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_motivation_short = /** @type {((inputs?: Intake_Why_Motivation_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Motivation_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_motivation_short(inputs)
	if (locale === "es-419") return es_419_intake_why_motivation_short(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_motivation_short(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_motivation_short(inputs)
	if (locale === "de-DE") return de_de2_intake_why_motivation_short(inputs)
	if (locale === "it-IT") return it_it2_intake_why_motivation_short(inputs)
	return en_us2_intake_why_motivation_short(inputs)
});
export { intake_why_motivation_short as "intake.why.motivation.short" }